var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.reportLoaded)?_c('div',_vm._l((_vm.report.results),function(reportData,index){return _c('route-plan-history-report-card',{key:index,attrs:{"customer-report":reportData,"start-date":_vm.startDate,"end-date":_vm.endDate}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }